import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";
import { formatWebVitalMetric, observeWebVitals } from "@/lib/webVitals";

export function CoreWebVitalsTracker(): React.JSX.Element | null {
  const location = useLocation();
  const pageRef = useRef(`${location.pathname}${location.search}${location.hash}`);

  useEffect(() => {
    pageRef.current = `${location.pathname}${location.search}${location.hash}`;
  }, [location.hash, location.pathname, location.search]);

  useEffect(() => {
    return observeWebVitals((metric) => {
      const formattedMetric = formatWebVitalMetric(metric);

      trackEvent("core_web_vital_recorded", {
        metric: metric.name,
        metric_id: metric.id,
        page: pageRef.current,
        rating: metric.rating,
        navigation_type: metric.navigationType,
        value: formattedMetric.value,
        display_value: formattedMetric.displayValue,
        unit: formattedMetric.unit,
        threshold: formattedMetric.threshold,
      });
    });
  }, []);

  return null;
}
